import { isCoreSRP, isCoreSrpMMYS, isMakeTypeSRP } from 'site-modules/shared/utils/inventory/srp-type-checkers';
import { buildCoreBreadcrumbs } from 'site-modules/shared/utils/core-breadcrumbs-builder';
import { getMakeTypeBreadcrumbs } from 'site-modules/shared/components/breadcrumbs/srp-helper';
import { generateSEOBreadcrumbs } from 'site-modules/shared/utils/inventory/srp-seo-utils';

/**
 * Builds the makeModelSubmodelYear-shaped object required by buildCoreBreadcrumbs
 * from the raw vehicle object in inventory attributes.
 *
 * @param {object} vehicle - Raw vehicle from attributes (uses niceId for slugs).
 * @param {object} params - Route params { year, submodel }.
 * @returns {object|null}
 */
function buildMakeModelSubmodelYear(vehicle, params) {
  if (!vehicle?.make || !vehicle?.model || !vehicle?.modelYear) return null;
  const { submodelName, submodel } = params;

  return {
    make: { ...vehicle.make, slug: vehicle.make.niceId },
    model: { ...vehicle.model, slug: vehicle.model.niceId },
    year: vehicle.modelYear.year,
    submodels: params.submodel ? { name: submodelName, slug: submodel } : {},
    pubStates: { USED: true },
  };
}

/**
 * Builds breadcrumbs for SRP based on the URL pattern.
 *
 * @param {object} params
 * @param {object} params.seoData
 * @param {object|null} params.vehicle - Raw vehicle object from inventory attributes.
 * @param {object} params.routeParams - Route params { year, submodel }.
 * @param {string} params.pathName
 * @returns {Array}
 */
export function getSrpBreadcrumbs({ seoData, vehicle, routeParams, pathName }) {
  const { urlPattern } = seoData;

  if (isCoreSRP(urlPattern) || isCoreSrpMMYS(urlPattern)) {
    return buildCoreBreadcrumbs({
      makeModelSubmodelYear: buildMakeModelSubmodelYear(vehicle, {
        ...routeParams,
        submodelName: seoData?.submodelFromUrlContext,
      }),
      params: routeParams,
      includeLastLink: true,
    });
  }

  if (isMakeTypeSRP(urlPattern)) {
    return getMakeTypeBreadcrumbs(seoData);
  }

  return generateSEOBreadcrumbs({
    originalUrl: pathName,
    seoData,
    includeLastLink: true,
  });
}
